import React, {useContext} from "react";
import { useState} from "react";
import Rating from '@mui/material/Rating';
import StarIcon from '@mui/icons-material/Star';
import axios from 'axios';
import { BaseURL } from "../../Files/BaseURL";
import Alert from "../../Context/Alert/AlertContext";


const ReviewPopup = ({setIsReviewPopupVisible, offerId, userId, reviewBtn}) =>{

    const [loading, setLoading] = useState(false);
    const { showAlert } = useContext(Alert);
    const closePopup = () => {
        setIsReviewPopupVisible(false);
    };

    const [value, setValue] = useState(0);
    const [message, setMessage] = useState('');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const reviewed = async() => {
        if(!value || !message){
            showAlert("Please fill all fields","danger");
            return;
        }
        setLoading(true);
        try{
            const response = await axios.post(`${BaseURL}/api/review/createReview`, {
                reviewedTo: userId,
                message: message,
                rating: value,
                offer: offerId
            }, {
                headers: {
                    'auth-token': localStorage.getItem('p@token')
                }
            })

            if(response.status === 200){
                reviewBtn(false);
                setLoading(false);
                setIsReviewPopupVisible(false);
            }
            else{
                setLoading(false);
                setIsReviewPopupVisible(false);
                showAlert("Failed to create review", "danger");
            }
        }
        catch(error){
            console.error(error);
            setLoading(false);
            setIsReviewPopupVisible(false);
        }
    }
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[9999]">
            <div className="bg-white p-4 md:p-6 rounded-lg shadow-lg w-11/12 md:w-2/3 lg:w-1/3 flex flex-col">
                <h1 className="text-xl mb-4 font-pop flex pt-2 pb-4 justify-center text-lightGrey font-semibold">Share your experience</h1>

                <div className={'flex justify-between'}>
                <h2 className="mb-4 font-pop text-lightGrey font-semibold">Rating: </h2>
                <Rating
                    name="simple-controlled"
                    value={value}
                    onChange={handleChange}
                    emptyIcon={<StarIcon style={{ color: 'grey' }} />}
                    filledIcon={<StarIcon style={{ color: 'gold' }} />}
                />
                </div>
                <textarea
                        className="w-full border-gray-200 rounded-lg bg-transparent resize-none overflow-hidden max-h-[50vh] my-2 hover:border-green-500 focus:border-green-500"
                        placeholder="Write your review here..."
                        rows={4}
                        style={{height: 'auto'}} onInput={(e) => {
                            e.target.style.height = 'auto';
                            e.target.style.height = `${e.target.scrollHeight}px`;}
                } onChange={(e) => setMessage(e.target.value)}
                ></textarea>

                <div className="flex justify-end gap-4">
                <button
                        className="my-4 w-fit px-2 md:px-6 bg-green-500 hover:bg-transparent  hover:bg-white-500 font-semibold hover:text-black font-pop text-sm md:text-base py-1 md:py-2 border border-black-500 hover:border-green-500 rounded-full  text-white"
                        onClick={reviewed}
                        disabled={loading}
                    >
                        {loading ? 'Loading...' : 'Review'}
                    </button>
                    <button
                        className="my-4 w-fit px-2 md:px-6 hover:bg-green-500 bg-white-500 font-semibold text-black font-pop text-sm md:text-base py-1 md:py-2 border border-black-500 hover:border-green-500 rounded-full  hover:text-white"
                        onClick={closePopup}
                    >
                        Cancel
                    </button>

                </div>
            </div>
        </div>
    )


}

export default ReviewPopup;